
angular.module('tf.directives')

    .directive('lineChart', ['C3Service','Legend', function(C3Service, Legend) {
    return {
        restrict: 'E',
        template: '<div class="tf-line"></div>',
        replace: true,
        scope:{
            data    :"=",
            options :"=?"
        },
        link : function(scope,element,attr){

            var data = scope.data? C3Service.line(scope.data.series, scope.data.values) : [];
            var options = scope.options || {};
            var chart = c3.generate({
                bindto : element[0],
                data: {
                    type: 'area',
                    x : 'x',
                    // xFormat: '%m/%d/%Y',
                    xFormat: '%Y-%m-%d',
                    columns : data
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            format: '%d-%m-%Y'
                            //count: 5
                        },
                        padding: {left: 2, right: 0}
                    },
                    y: {
                        tick: {
                            //count:5
                            format: function(x) {
                                return (x == Math.floor(x)) ? x : "";
                            }
                        },
                        padding: {top: 50, bottom: 2}
                    }
                },
                tooltip: {
                    grouped: true,
                    format: {
                        title: function (d) {
                            return moment(d).format('ddd, MMM-DD');
                        }
                    }
                },
                point: {
                    show: true,
                    r : 4,
                    select : {
                        r : 5
                    }
                },
                color: {
                    pattern: scope.options.colors
                },
                legend: {
                    show: false
                },
                onrendered: function () {
                    Legend.create(element, this.api, scope.data, scope.options.clickKey);
                }
            });


            var unwatch = scope.$watch('data', function(data){
                if(data) {
                    chart.load({
                        unload: true,
                        columns: C3Service.line(data.series, data.values),
                        done : function(){
                            chart.show();
                            var categories = C3Service.getSortedCategories(data.values);
                            chart.hide(categories.slice(5,categories.length));
                        }
                    });

                }
            });

        }
    };

}]);